import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { Edit, DeleteOutline } from "@mui/icons-material";
import CommonTable, { HeadCell } from "src/business-types/grocery/components/CommonTable";
import Image from "src/shared/Image";
import { Staff } from "src/shared/services/interfacev2";

interface StaffTableProps {
  staffData: Staff[];
  filteredData: Staff[];
  onEdit: (staff: Staff) => void;
  onDelete: (id: string, name: string) => void;
  showDeletedStaffs: boolean;
}

const StaffTable: React.FC<StaffTableProps> = ({ filteredData, onEdit, onDelete, showDeletedStaffs }) => {
  const headCells: HeadCell<any>[] = [
    { id: "sno", label: "S.No" },
    { id: "staffName", label: "Staff Name" },
    { id: "phoneNumber", label: "Phone Number" },
    { id: "emails", label: "Emails" },
    { id: "staff_image_key", label: "Image" },
    { id: "actions", label: "Actions" },
  ];

  const tableData = filteredData.map((staff, index) => ({
    id: staff._id?.$oid || index,
    sno: index + 1,
    staffName: [staff.firstName, staff.middleName, staff.lastName].filter(Boolean).join(" "),
    phoneNumber: staff.phones?.[0]?.phone || "",
    emails: staff.emails?.[0]?.email || "",
    staff_image_key: (
      <div className='w-10 h-10 rounded-md object-contain overflow-hidden'>
        <Image imagePath={staff.staffImageKey} />
      </div>
    ),
    actions: (
      <div className='flex gap-1'>
        <Tooltip title='Edit' placement='bottom' arrow>
          <span>
            <IconButton
              size='small'
              disabled={showDeletedStaffs}
              onClick={(e) => {
                e.stopPropagation();
                if (!showDeletedStaffs) onEdit(staff);
              }}
            >
              <Edit style={{ color: showDeletedStaffs ? "gray" : "black" }} />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title='Delete' placement='bottom' arrow>
          <span>
            <IconButton
              size='small'
              disabled={showDeletedStaffs}
              onClick={(e) => {
                e.stopPropagation();
                if (!showDeletedStaffs) onDelete(staff._id?.$oid, staff.firstName);
              }}
            >
              <DeleteOutline style={{ color: showDeletedStaffs ? "lightgray" : "red" }} />
            </IconButton>
          </span>
        </Tooltip>
      </div>
    ),
  }));

  // ✅ Render
  return (
    <div className="thin-scrollbar shadow-inner rounded-lg p-1 bg-white w-[95%] overflow-y-auto">
      <CommonTable
        title='Staff List'
        data={tableData}
        headCells={headCells}
        selectable={false}
        showFilterIcon={false}
        showToolbar={false}
        pagenation={true}
        className="w-full"
      />
    </div>
  );
};

export default StaffTable;
